import ContactUs from '@/components/ContactUs';
import { Tit } from '@/components/Titles';
import React, { FC } from 'react';
import styled from 'styled-components';

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `후원자모집팀`,
    tel: `02-721-5142`,
    email: `igshop@unicef.or.kr`,
  },
];

const StepContainer = styled.div`
  padding-top: 32px;

  .dec {
    margin-top: 32px;
    margin-bottom: 72px;
  }
  .btn-wrap {
    margin-top: 80px;
    text-align: center;
  }
`;

const PartyAppyComplete: FC = () => (
  <form>
    <StepContainer>
      <Tit size="s1-5" color="sky" weight="normal">
        Party for UNICEF <br />
        활동후기가 제출되었습니다.
      </Tit>
      <p className="dec">
        작성해주신 후기 내용은 웹사이트 '파티이야기'에 소개해드리며,{` `}
        <br className="m-hide" />
        우수 활동 팀을 선정하여 감사 선물을 드립니다. 유니세프를 알리고
        어린이들의 꿈을 이루는 데에 동참해주신 모든 후원자님께 감사합니다.{` `}
        <br />
      </p>
      <ContactUs itemData={contactData} />
    </StepContainer>
  </form>
);
export default PartyAppyComplete;
